import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Spinner } from 'react-bootstrap';

function CancelCompetitionModal({ onCancel, loadingCancellation, ...props }) {
  return (
    <Modal
      {...props}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Är du säker på att du vill ställa in tävlingen?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Du är nu på väg att ställa in tävlingen. Detta går ej att ångra.
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button onClick={() => props.onHide()} variant='outline-secondary'>
          Avbryt
        </Button>
        <Button onClick={onCancel}>
          Fortsätt
          {loadingCancellation && (
            <>
              {' '}
              <Spinner
                as='span'
                animation='border'
                size='sm'
                role='status'
                aria-hidden='true'
                className='me-2'
              />
              <span className='visually-hidden'>Loading...</span>
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CancelCompetitionModal;
